var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "textPicker",
      on: {
        mousedown: function ($event) {
          $event.stopPropagation()
        },
        touchstart: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _c(
        "ul",
        { staticClass: "picker one" },
        _vm._l(_vm.collection, function (fontModel) {
          return _c("FontPickerItemView", {
            key: fontModel.id,
            staticClass: "pickerItem",
            attrs: { "font-model": fontModel, "page-model": _vm.pageModel },
            on: { imageLoaded: _vm.imageLoaded, selectFont: _vm.selectFont },
          })
        }),
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }